import isNumber from "./number";

export default function isMin(value, min) {
  if (isNumber(value)) {
    return Number(value) >= min;
  } else if (typeof value === "string") {
    return value.length >= min;
  }

  return false;
}
